module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Beggingen-d80545839c2c3cf6ea17043e60f532bf.png";